import {Dispatch, ReactNode, SetStateAction, useEffect} from 'react';

import AdobeTargetContext from 'components/app/AdobeTargetProvider/AdobeTargetContext';
import {AdobeTargetAllMBoxValues} from 'components/app/AdobeTargetProvider/types';
import {getBaseAddress} from 'features/Quoting/hooks/queries';
import {handleAdobeOffers, useSyncHistoryToTarget} from 'utils/adobe-target';

interface Props {
  adobe: any;
  pathname: any;
  isAdobeLoaded: boolean;
  children: ReactNode;
  parameters: AdobeTargetAllMBoxValues;
  setParameters: Dispatch<SetStateAction<AdobeTargetAllMBoxValues>>;
}

const AdobeTargetBaseProvider = ({adobe, pathname, isAdobeLoaded, children, parameters, setParameters}: Props) => {
  useEffect(() => {
    handleAdobeOffers(setParameters, adobe, {webQuoteState: getBaseAddress()?.state});
  }, [adobe, pathname, isAdobeLoaded, setParameters]);
  useSyncHistoryToTarget(isAdobeLoaded, adobe);

  return <AdobeTargetContext.Provider value={parameters}>{children}</AdobeTargetContext.Provider>;
};
export default AdobeTargetBaseProvider;
